/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const ArrowLeft14 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={8} height={14} viewBox="0 0 8 14" {...props}>
    <path fill="currentColor" fillRule="evenodd" d="M8 1.933 6.555.5 0 7l6.555 6.5L8 12.067 2.891 7z" />
  </svg>
);

export const __descriptor_ArrowLeft = {
  name: "ArrowLeft",
  instances: [{ size: 14, Component: ArrowLeft14 }],
} as const;
